exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toucharea{margin:4px;background:#fff;padding:40px 0}.infobox{padding:20px;text-align:left;background:#fff;margin-bottom:10px}", "", {"version":3,"sources":["/./src/other/touch/demo.vue"],"names":[],"mappings":"AACA,WACE,WAAY,AACZ,gBAAiB,AACjB,cAAgB,CACjB,AACD,SACE,aAAc,AACd,gBAAiB,AACjB,gBAAiB,AACjB,kBAAoB,CACrB","file":"demo.vue","sourcesContent":["\n.toucharea{\n  margin: 4px;\n  background: #fff;\n  padding: 40px 0;\n}\n.infobox{\n  padding: 20px;\n  text-align: left;\n  background: #fff;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-f679ecde!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/other/touch/demo.vue
// module id = 175
// module chunks = 33